const ChartMixin = {
  data () {
    return {
      colors: [
        '#F68D2E',
        '#FF5521', 
        '#F5FF91', 
        '#019587', 
        '#162FB7', 
        '#E91D62', 
        '#9D9D9D', 
        '#FF9700', 
        '#8BC24A', 
        '#73EEFF', 
        '#3E50B4', 
        '#FF6398', 
        '#607C8A', 
        '#FEC107',
        '#288442',
        '#02A8F4',
        '#6739B6',
        '#795549',
        '#FFE93B',
        '#69F6AF',
        '#2F5FC0',
        '#9C26B0'
      ]
    }
  },
  computed: {
    graphOptions () {
      return {
        curveType: 'function',
        legend: { position: 'none' },
        tooltip: {
          isHtml: true
        },
        hAxis: {
            title: 'Duration (min)',
            titleTextStyle: {
                color: '#5E5E62',
                italic: false,
                fontName: 'Roboto',
                fontSize: 14
            },
            viewWindow: {
                max: parseInt(this.duration),
                min: 0,
            },
            gridlines: {
                color: '#222224',
                count: 7
            },
            ticks: this.xTicks,
            baselineColor: '#5E5E62',
            textStyle: {
                fontSize: 14,
                bold: true
            },
        },
        vAxis: {
            title: this.vAxisTitle || '',
            titleTextStyle: {
                color: '#5E5E62',
                italic: false,
                fontName: 'Roboto',
                fontSize: 14
            },
            gridlines: {
                color: '#222224',
                count: 10
            },
            viewWindow: this.vAxisMaxMinValues,
            textStyle: {
                fontSize: 14,
                bold: true
            },
            ticks: this.vAxisTicks,
            baseline: this.vAxisBaseline,
            baselineColor: '#5E5E62'
        },
        interpolateNulls: true,
        backgroundColor: 'transparent',
        chartArea: {
            backgroundColor: {
                stroke: '#222224',
                strokeWidth: 3
            }
        },
        colors: this.colors,
        series: {
          0: { lineWidth: 5 }
        },
        width: '100%',
        chartArea: {
            left: 60,
            right: 20,
            top: 40,
            bottom: 70,
            width: '100%',
            height: '90%'
        }
      }
    }
  }
}

export default ChartMixin
